<template>
  <div class="BatterVisitViewContainer">
    <img src="../../assets/image/background.png" class="bg" />
    <StationMapView :menus="menus" :menusListLeft="menusListLeft"
                    :station-type="2"
                    @action="onAction"
                    @goNavigation="goNavigation"
                    :evaluate="{
                      type: 'STATION_TRAIN',
                      name: '培训评价'
                    }"
                    :icon="icon"
                    action-btn="预约培训"></StationMapView>
  </div>
</template>

<script>
import StationMapView from "../map/StationMapView"
export default {
  name: "BatterVisitView",
  components: {StationMapView},
  data() {
    return {
      menus:[
        {
          img:'https://cdn.waityou.online/6137ea4c-d23a-6dc0-371d-a3b7d28d885e.png',
          name:'参观',
          link:'/visit'
        },
        {
          img:'https://cdn.waityou.online/4b9948f5-57b7-5c07-6dc2-b97f7dc81c31.png',
          name:'演练',
          link:'/drill/'
        },
        {
          img:'https://cdn.waityou.online/21ea60b1-bc20-6cdc-3c34-84f9b185bdfb.png',
          name:'学习',
          link:'/study'
        },
        {
          img:'https://cdn.waityou.online/c323b885-0d6b-70b9-6eed-d5d1a51afd6c.png',
          name:'咨询',
          link:'/consult'
        },
      ],
      menusListLeft: [
        {
          img: require('../../assets/image/left_0.jpg'),
          name: '参观',
          link: '/visit'
        },
        {
          img: require('../../assets/image/left_2.png'),
          name: '演练',
          link: '/drill/'
        },
        {
          img: require('../../assets/image/left_3.png'),
          name: '学习',
          link: '/study'
        }
      ],
      icon:require('../../assets/image/train_icon.png'),
    }
  },
  methods: {
    onAction(station) {
      // Toast.warn('即将上线,敬请期待');
      this.$router.push('/teach/date/'+station.id)
    },
    goNavigation(station){
      // eslint-disable-next-line no-undef
      ZWJSBridge.openLink({
        url: `zwfw://openThirdMap?longitude=${station.longitude}&latitude=${station.latitude}&locationName=${station.name}`
      }).then((result) => {
        console.log(result);
      }).catch((error) => {
        console.log(error);
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.BatterVisitViewContainer {
  display: flex;
  flex-direction: column;
  // padding-bottom: 100px;
  .bg{
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
  }
}
</style>